/**
 * Filename: 全局组件
 *
 * description: 组件name必须正确
 * Copyright (c) 2022 Your Company
 */
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
const requireComponent = require.context('@/components/', // 需要读取模块的文件的所在目录
true, // 是否遍历子目录
/\.vue$/ // 匹配的规则（正则表达式）
);
export default {
    install: (app) => {
        requireComponent.keys().forEach((fileName) => {
            if (fileName.startsWith('./')) {
                const componentConfig = requireComponent(fileName);
                app.component(componentConfig.default.__name, componentConfig.default || componentConfig);
            }
        });
        for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
            app.component(key, component);
        }
    },
};
